import React from 'react';
import { faFileLines, faUpload, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { UploadedDocument } from '../../../models/FlowOfFunds/flow-of-funds.model';

export interface EvidenceDocumentSlotProps {
    document: UploadedDocument | null;
    canUpload: boolean;
    canRemove: boolean;
    uploadLabel: string;
    isUploadPending: boolean;
    isRemovePending: boolean;
    isViewPending: boolean;
    inputId: string;
    onUpload: (file: File) => void;
    onRemove: () => void;
    onView: () => void;
}

export const EvidenceDocumentSlot = ({
    document,
    canUpload,
    canRemove,
    uploadLabel,
    isUploadPending,
    isRemovePending,
    isViewPending,
    inputId,
    onUpload,
    onRemove,
    onView,
}: EvidenceDocumentSlotProps) => {
    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        event.target.value = '';
        if (file) {
            onUpload(file);
        }
    };

    if (document) {
        return (
            <span className="ff-wires__doc">
                <FontAwesomeIcon icon={faFileLines} className="ff-wires__doc-icon" />
                <button
                    type="button"
                    className="ff-wires__doc-name-button"
                    disabled={isViewPending}
                    onClick={onView}>
                    {isViewPending ? 'Opening…' : document.fileName}
                </button>
                {canRemove && (
                    <button
                        type="button"
                        title="Remove"
                        className="ff-wires__doc-remove"
                        disabled={isRemovePending}
                        onClick={onRemove}>
                        <FontAwesomeIcon icon={faXmark} />
                    </button>
                )}
            </span>
        );
    }

    if (!canUpload) {
        return <span className="ff-wires__doc-empty">No evidence uploaded</span>;
    }

    return (
        <label
            htmlFor={inputId}
            className={`ff-wires__upload${isUploadPending ? ' is-pending' : ''}`}>
            <FontAwesomeIcon icon={faUpload} /> {isUploadPending ? 'Uploading…' : uploadLabel}
            <input
                type="file"
                id={inputId}
                className="ff-wires__doc-input"
                disabled={isUploadPending}
                onChange={handleFileChange}
            />
        </label>
    );
};
